import { useEffect, useRef } from "react";

export default function useDebounce(callback: Function, delay = 300) {
  const timeoutRef = useRef(null);

  useEffect(() => {
    // 组件卸载时清除定时器
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };
}
